import { useEffect, useRef, useState, type RefObject } from 'react';

/**
 * Moves the focus to the first invalid field of a form after the render that shows the errors
 * (call `focusFirstInvalid()` in the same handler that sets them). Fields are found by
 * `aria-invalid="true"`, which Fluent's `Field` sets on its control, or by a fieldset marked
 * `data-invalid="true"` (a checkbox group).
 */
export function useFocusFirstInvalid(): {
  formRef: RefObject<HTMLFormElement | null>;
  focusFirstInvalid: () => void;
} {
  const formRef = useRef<HTMLFormElement>(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (tick === 0) return;
    formRef.current
      ?.querySelector<HTMLElement>('[aria-invalid="true"], fieldset[data-invalid="true"] input')
      ?.focus();
  }, [tick]);
  return {
    formRef,
    focusFirstInvalid: () => {
      setTick((current) => current + 1);
    },
  };
}
